import React, { DragEvent } from "react";
import { ATTACHMENT_FIELD_STYLES } from "./styles";

interface DragDropZoneProps {
  isDragOver: boolean;
  disabled: boolean;
  acceptedFileTypes: string;
  onDragOver: (event: DragEvent<HTMLDivElement>) => void;
  onDragLeave: (event: DragEvent<HTMLDivElement>) => void;
  onDrop: (event: DragEvent<HTMLDivElement>) => void;
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DragDropZone: React.FC<DragDropZoneProps> = ({
  isDragOver,
  disabled,
  acceptedFileTypes,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileSelect
}) => {
  return (
    <div
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      style={ATTACHMENT_FIELD_STYLES.dragDropZone(isDragOver, disabled)}
    >
      <input
        type="file"
        multiple
        onChange={onFileSelect}
        disabled={disabled}
        style={ATTACHMENT_FIELD_STYLES.hiddenInput}
        id="file-input"
        accept={acceptedFileTypes}
      />
      <label
        htmlFor="file-input"
        style={ATTACHMENT_FIELD_STYLES.label(disabled)}
      >
        📁
        <br />
        파일을 선택하거나 여기에 드래그하세요
        <br />
        <small style={ATTACHMENT_FIELD_STYLES.helpText}>
          여러 파일을 동시에 선택할 수 있습니다
        </small>
      </label>
    </div>
  );
};

export default DragDropZone;
